<template>
    <div>
        <app-finalizacao :finalizacao="finalizacao">
            <template slot="footer">
                <app-btn-voltar></app-btn-voltar>
            </template>
        </app-finalizacao>
        <app-entregas
            :entregas="entregasDisponiveis"
            :incluirSelecao="true"
            titulo="Entregas Disponíveis"
        >
            <template slot="botoes">
                <b-button-group class="float-right">
                    <b-button
                        variant="primary"
                        @click="confirmaAssociarSelecionadas()"
                        :disabled="entregasDisponiveisSelecionadas.length === 0"
                        >Associar selecionadas</b-button
                    >
                </b-button-group>
            </template>
            <template slot="entregaSelecao" slot-scope="data">
                <b-form-checkbox
                    :value="data.entregaId"
                    v-model="entregasDisponiveisSelecionadas"
                ></b-form-checkbox>
            </template>
        </app-entregas>
    </div>
</template>

<script>
import Finalizacao from './FinalizacaoDetalhar'
import Entregas from './../entregas/Entregas2'

export default {
    props: {
        finalizacoesServicos: {
            type: Object,
            default: () => ({})
        },

        finalizacao: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            entregasDisponiveisSelecionadas: [],
            entregasDisponiveis: []
        }
    },

    methods: {
        obterEntregasDisponiveis() {
            this.$store.dispatch('addRequest')
            this.finalizacoesServicos
                .obterEntregasDisponiveis(this.$route.params.finalizacaoId)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.entregasDisponiveis = response.data
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        confirmaAssociarSelecionadas() {
            this.$swal({
                title: 'Associação de Entregas',
                html: `Confirma a associação das entregas selecionadas?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.associarEntregas()
                }
            })
        },

        associarEntregas() {
            this.$store.dispatch('addRequest')
            this.finalizacoesServicos
                .associarEntregas({
                    finalizacaoId: this.$route.params.finalizacaoId,
                    entregasId: this.entregasDisponiveisSelecionadas
                })
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro salvo com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.entregasDisponiveisSelecionadas = []
                            this.obterEntregasDisponiveis()
                            this.$emit('obterFinalizacaoAtualizada')
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    created() {
        this.obterEntregasDisponiveis()
    },

    components: {
        AppEntregas: Entregas,
        AppFinalizacao: Finalizacao
    }
}
</script>
